import StatisticsCell from './StatisticsCell';

export default StatisticsCell;
